"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyContext = void 0;
exports.default = CopyProvider;
exports.useCopy = useCopy;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CopyContext = exports.CopyContext = /*#__PURE__*/(0, _react.createContext)();
function CopyProvider(_ref) {
  var {
    children
  } = _ref;
  var [copyValue, setCopyValue] = (0, _react.useState)(0);
  return /*#__PURE__*/_react.default.createElement(CopyContext.Provider, {
    value: {
      copyValue,
      setCopyValue
    }
  }, children);
}
function useCopy() {
  return (0, _react.useContext)(CopyContext);
}